import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import IcomoonReact from 'icomoon-react';
import selection from './selection.json.js';

var _excluded = ["color", "size", "icon", "className", "children", "iconAfter"];
var Picon = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var color = _ref.color,
    size = _ref.size,
    icon = _ref.icon,
    className = _ref.className,
    children = _ref.children,
    iconAfter = _ref.iconAfter,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (children) {
    if (iconAfter === true) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, children, /*#__PURE__*/React.createElement(IcomoonReact, _extends({
        className: className,
        iconSet: selection,
        color: color,
        size: size,
        icon: icon,
        ref: ref
      }, props)));
    } else {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IcomoonReact, _extends({
        className: className,
        iconSet: selection,
        color: color,
        size: size,
        icon: icon,
        ref: ref
      }, props)), children);
    }
  }
  return /*#__PURE__*/React.createElement(IcomoonReact, _extends({
    className: className,
    iconSet: selection,
    color: color,
    size: size,
    icon: icon,
    ref: ref
  }, props));
});

// const PiconIcons = iconList(selection).sort()

Picon.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  color: PropTypes.string,
  icon: PropTypes.string,
  /** If there are children, whether to render the icon after the children */
  iconAfter: PropTypes.bool,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Picon.defaultProps = {
  iconAfter: false,
  size: '56'
};
Picon.displayName = 'Picon';

export { Picon as default };
//# sourceMappingURL=index.js.map
